export enum IntegratedCareChannel {
  CREATE = 'integratedCare::create',
  EDIT = 'integratedCare::patch',
  DELETE = 'integratedCare::delete',
}
